import React, { Component, Fragment, useState, useEffect } from "react";
import Slider from "react-slick";
import ScrollToTop from "react-scroll-up";
import { Link } from "react-router-dom";
import { FiChevronUp } from "react-icons/fi";
import Header from "../component/header/Header";
import FooterTwo from "../component/footer/Footer";
import Brand from "../elements/Brand";
import CounterOne from "../elements/counters/CounterOne";
import TeamHome from "../blocks/team/TeamHome";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { withTranslation } from "react-i18next";
import ProjectHome from "../blocks/project/ProjectHome";
import NewsList from "../elements/news/NewsList";
import controllers from "../controllers/events";
import LoaderData from "../component/LoaderData/LoaderData";

const slideSlick = {
  infinite: true,
  autoplay: false,
  speed: 500,
  autoplaySpeed: 4000,
  slidesToShow: 3,
  slidesToScroll: 1,
  dots: false,
  arrows: true,
  fade: true,
  easing: "fade",
  adaptiveHeight: true,
};

const programsArray = [
  {
    title: {
      fr: "Master Exécutif en stratégies des Smart cities en Afrique",
      en: "Master Exécutif en stratégies des Smart cities en Afrique",
    },
    description: {
      fr: "Le Master Exécutif spécialisé dans les stratégies des Smart cities en Afrique est un programme académique d'une durée d'un an. Ce programme est spécifiquement conçu pour les professionnels en activité et les individus souhaitant développer des compétences avancées dans le domaine de la gestion urbaine",
      en: "Le Master Exécutif spécialisé dans les stratégies des Smart cities en Afrique est un programme académique d'une durée d'un an. Ce programme est spécifiquement conçu pour les professionnels en activité et les individus souhaitant développer des compétences avancées dans le domaine de la gestion urbaine",
    },
    image: "/assets/images/programs/master1.png",
    link: "/educations",
  },
];

const HomePage = ({ i18n }) => {
  const isEnglish = i18n.language === "en";
  const [slideItems, setSlideItems] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const newsRes = await controllers.getEventsList({
          limit: 10,
          page: 0,
        });

        const yearForComparison = 2025;
        const cutoff = new Date(`${yearForComparison}-04-20T00:00:00.000Z`); // UTC
        
        let eventsFromApi = [];
        
        if (newsRes &&newsRes.length > 0) {
          newsRes.forEach((event, index) => {
            const eventDate = new Date(event.date);
          });
          
          const filteredByDate = newsRes.filter(event => {
            try {
              const eventDate = new Date(event.date);
              return eventDate < cutoff;
            } catch (err) {
              console.error("Error comparing dates:", err, event);
              return false;
            }
          });
          
          eventsFromApi = filteredByDate.slice(0, 2);
          
        }
        

        const oneProgram = programsArray[0];
        
        const combinedSlides = [...eventsFromApi, oneProgram];
        

        setSlideItems(combinedSlides);
        setLoading(false);
      } catch (err) {
        console.error(err);
        window.location.href = "/500";
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const getLink = (item) => {
    if (item.link) {
      return item.link;
    } else {
      const slug = item.title.en?.split(" ").join("-") ?? "untitled";
      return `/news/${slug}/?id=${item.id}`;
    }
  };

  const getImageSrc = (item) => {
    if (item.event_id && item.image) {
      return `${process.env.REACT_APP_DOMAIN}/api/eventsimages/${item.event_id}/${item.image}`;
    } else if (item.image) {
      return item.image;
    }
    return null;
  };

  const truncateWords = (htmlString = "", limit = 10) => {
    const plainText = htmlString
      .replace(/<[^>]+>/g, "")
      .replace(/\s+/g, " ")
      .trim();

    const words = plainText.split(" ");
    return words.length > limit
      ? words.slice(0, limit).join(" ") + "..."
      : plainText;
  };

  return (
    <Fragment>
      <Header logo="light" color="color-white" />

      <div className="slider-wrapper color-white">
        <div className="slider-activation slider-digital-agency">
          <Slider className="rn-slick-dot dot-light" {...slideSlick}>
            {loading && <LoaderData />}

            {!loading &&
              slideItems &&
              slideItems.length > 0 &&
              slideItems.map((item, index) => {
                const bgImage = getImageSrc(item);

                return (
                  <div key={index}>
                    <div
                      className="slide slide-style-2 fullscreen d-flex align-items-center justify-content-center"
                      style={{
                        backgroundImage: `url(${bgImage})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        minHeight: "100vh",
                      }}
                    > 
                      <div
                        style={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          right: 0,
                          bottom: 0,
                          backgroundColor: "rgba(0, 0, 0, 0.4)",
                          zIndex: 1,
                        }}
                      ></div>

                      <div
                        className="container"
                        style={{ position: "relative", zIndex: 2 }}
                      >
                        <div className="row">
                          <div className="col-lg-12">
                            <div className="inner text-left">
                              {item.title && (
                                <h1 className="title">
                                  {truncateWords(
                                    isEnglish ? item.title.en : item.title.fr,
                                    10
                                  )}
                                </h1>
                              )}
                              {item.description && (
                                <p className="description">
                                  {truncateWords(
                                    isEnglish
                                      ? item.description.en
                                      : item.description.fr,
                                    20
                                  )}
                                </p>
                              )}

                              <div className="slide-btn">
                                <a className="btn-default" href={getLink(item)}>
                                  {isEnglish ? "Read More" : "Lire Plus"}
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
          </Slider>
        </div>
      </div>

      <div id="about" className="about-wrapper  pt--50 pb--50 bg_color--1">
        <div className="container">
          <div className="row row--35 align-items-center">
            <div className="col-lg-12 col-md-12">
              <div className="about-inner inner">
                {isEnglish ? (
                  <div className="section-title">
                    <h2 className="title">Global context & challenges</h2>
                    <p className="description">
                      Over the next two decades, Africa (particularly
                      sub-Saharan Africa) will experience a very strong
                      demographic surge, which should correspond to more than
                      860 million new city dwellers. The population and surface
                      area of cities will double in one generation. This
                      represents a major challenge, both spatially and socially.
                      While urbanization is a global trend, the challenges will
                      be greatest on the African continent.
                    </p>
                    <p className="description">
                      In addition, a new urban revolution - the digital
                      revolution - is profoundly transforming the way we manage
                      and design cities. It offers new opportunities (new types
                      of data (perception, real time, opinions, ideas) and a new
                      quantity of data (big urban data). For example, over 90%
                      of the world's data has been produced in the last 2 years.
                    </p>
                    <div className="purchase-btn">
                      <Link className="btn-transparent" to="/about">
                        {isEnglish ? "Read More" : "Voir plus"}
                      </Link>
                    </div>
                  </div>
                ) : (
                  <div className="section-title">
                    <h2 className="title">Contexte mondial et défis</h2>
                    <p className="description">
                      Au cours des deux prochaines décennies, l'Afrique (en
                      particulier l'Afrique subsaharienne) connaîtra une très
                      forte poussée démographique, qui devrait correspondre à
                      plus de 860 millions de nouveaux citadins. La population
                      et la superficie des villes doubleront en une génération.
                      Il s'agit là d'un défi majeur, tant sur le plan spatial
                      que social. Si l'urbanisation est une tendance mondiale,
                      c'est sur le continent africain que les défis seront les
                      plus importants.
                    </p>
                    <p className="description">
                      Par ailleurs, une nouvelle révolution urbaine - la
                      révolution numérique - transforme profondément la façon
                      dont nous gérons et concevons les villes. Elle offre de
                      nouvelles opportunités (nouveaux types de données
                      (perception, temps réel, opinions, idées) et une nouvelle
                      quantité de données (big urban data). Par exemple, plus de
                      90 % des données mondiales ont été produites au cours des
                      deux dernières années.
                    </p>
                    <div className="purchase-btn">
                      <Link className="btn-transparent" to="/about">
                        Voir Plus
                      </Link>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="rn-about-us-area attacment-fixed rn-finding-us ptb--120 bg_color--1 bg_image bg_image--18"
        data-black-overlay="5"
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="inner">
                <div className="content-wrapper">
                  <div className="content">
                    <div className="section-title">
                      <span className="subtitle">
                        {isEnglish ? "About" : "A Propos"}
                      </span>
                      <h2 className="title">
                        {isEnglish ? "About" : "A Propos"}
                      </h2>
                    </div>
                    <div className="row mt--30">
                      <div>
                        <div className="tabs-area">
                          <div className="container">
                            <div className="row">
                              <div className="col-lg-12">
                                <Tabs>
                                  <TabList
                                    style={{ flexWrap: "inherit" }}
                                    className="tab-style--1"
                                  >
                                    <Tab className="w-100 text-center">
                                      {isEnglish ? "Objectives" : "Objectifs"}
                                    </Tab>
                                    <Tab className="w-100 text-center">
                                      Mission
                                    </Tab>
                                    <Tab className="w-100 text-center">
                                      Vision
                                    </Tab>
                                  </TabList>
                                  <TabPanel>
                                    <div className="single-tab-content">
                                      <div className="mt--30 mt_lg--10 mt_md--10 mt_sm--10">
                                        <h4>
                                          {isEnglish
                                            ? "Objectives"
                                            : "Objectifs"}
                                        </h4>
                                        <div className="description">
                                          {isEnglish ? (
                                            <ul style={{ paddingLeft: "18px" }}>
                                              <li>
                                                Change the angle of view of
                                                urban studies research in
                                                Africa, i.e., resolutely
                                                position research in the
                                                digital, data, and quantitative
                                                fields, but with a societal
                                                viewpoint, which gives it added
                                                value compared to other research
                                                on the continent and in the
                                                discipline of urban studies.
                                              </li>
                                              <li>
                                                To test new methods and put big
                                                data at the centre of
                                                reflections on the resolution of
                                                complex urban problems, and thus
                                                gain visibility through
                                                innovative methods.
                                              </li>
                                              <li>
                                                Position on the polytechnic
                                                vision as a central element of
                                                the centre.
                                              </li>
                                              <li>
                                                CUS's objectives include
                                                training future urban players,
                                                reflecting on cities in Morocco
                                                and Africa, and promoting
                                                excellence in urban systems
                                                engineering.
                                              </li>
                                            </ul>
                                          ) : (
                                            <ul style={{ paddingLeft: "18px" }}>
                                              <li>
                                                Changer l'angle de vue de la
                                                recherche en études urbaines en
                                                Afrique, c'est-à-dire
                                                positionner résolument la
                                                recherche dans les domaines du
                                                numérique, des données et du
                                                quantitatif, mais avec un regard
                                                sociétal, ce qui lui confère une
                                                valeur ajoutée par rapport aux
                                                autres recherches sur le
                                                continent et dans la discipline
                                                des études urbaines.
                                              </li>
                                              <li>
                                                Tester de nouvelles méthodes et
                                                mettre le big data au centre des
                                                réflexions sur la résolution de
                                                problèmes urbains complexes, et
                                                ainsi gagner en visibilité grâce
                                                à des méthodes innovantes.
                                              </li>
                                              <li>
                                                Se positionner sur la vision
                                                polytechnique comme élément
                                                central du centre.
                                              </li>
                                              <li>
                                                Les objectifs de CUS comprennent
                                                la formation des futurs acteurs
                                                urbains, la réflexion sur les
                                                villes du Maroc et de l'Afrique,
                                                et la promotion de l'excellence
                                                dans l'ingénierie des systèmes
                                                urbains.
                                              </li>
                                            </ul>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </TabPanel>
                                  <TabPanel>
                                    <div className="single-tab-content">
                                      <div className="mt--30 mt_lg--10 mt_md--10 mt_sm--10">
                                        <h4>Mission</h4>
                                        {isEnglish ? (
                                          <>
                                            <p>
                                              CUS is a center dedicated to
                                              research, education, and
                                              innovation in urban science. It
                                              uses Living Labs as a research and
                                              classroom environment to train
                                              future urban leaders and find
                                              innovative solutions to complex
                                              urban problems. CUS focuses on
                                              four pillars: research, education,
                                              expertise, and innovation, all
                                              aimed at improving urban
                                              management and citizen well-being.
                                            </p>
                                            <p>
                                              CUS transforms data collected by
                                              Living Labs to make them
                                              sustainable, viable, supportive,
                                              and cost-effective.
                                            </p>
                                            <p>
                                              CUS will train the next generation
                                              of urban systems engineers.
                                            </p>
                                          </>
                                        ) : (
                                          <>
                                            <p>
                                              Le CUS est un centre dédié à la
                                              recherche, à l'éducation et à
                                              l'innovation dans le domaine des
                                              sciences urbaines. Elle utilise
                                              les Living Labs comme
                                              environnement de recherche et de
                                              formation pour former les futurs
                                              leaders urbains et trouver des
                                              solutions innovantes à des
                                              problèmes urbains complexes. Le
                                              CUS se concentre sur quatre
                                              piliers : la recherche,
                                              l'éducation, l'expertise et
                                              l'innovation, qui visent tous à
                                              améliorer la gestion urbaine et le
                                              bien-être des citoyens.
                                            </p>
                                            <p>
                                              Le CUS transforme les données
                                              collectées par les Living Labs
                                              pour les rendre durables, viables,
                                              soutenables et économiques.
                                            </p>

                                            <p>
                                              La CUS formera la prochaine
                                              génération d'ingénieurs en
                                              systèmes urbains.
                                            </p>
                                          </>
                                        )}
                                      </div>
                                    </div>
                                  </TabPanel>
                                  <TabPanel>
                                    <div className="single-tab-content">
                                      <div className="mt--30 mt_lg--10 mt_md--10 mt_sm--10">
                                        <h4>Vision</h4>
                                        {isEnglish ? (
                                          <>
                                            <p>
                                              CUS aims to become a leader in
                                              education, research, and
                                              innovation in urban science, using
                                              Living Labs to train future urban
                                              leaders and find innovative
                                              solutions to complex urban
                                              problems. The CUS seeks to improve
                                              urban management and citizen
                                              well-being by transforming data
                                              collected by the Living Labs to
                                              make them sustainable, viable,
                                              supportive, and cost-effective. It
                                              will also strive to train the next
                                              generation of urban systems
                                              engineers, stimulate thinking
                                              about Morocco and Africa's cities,
                                              and promote excellence in urban
                                              systems engineering. To achieve
                                              these goals, CUS must create an
                                              ecosystem for a school of urban
                                              systems, train future teachers,
                                              and position itself on the
                                              international stage.
                                            </p>
                                            <p>
                                              Our vision integrates theory,
                                              project management, expertise, and
                                              innovation, focusing on the
                                              contemporary challenges of urban
                                              development. This integration not
                                              only encompasses urban innovation
                                              but also extends to innovative
                                              approaches in teaching, thus
                                              aligning with the digital,
                                              data-driven, and quantitative
                                              focus of urban studies research in
                                              Africa.
                                            </p>
                                          </>
                                        ) : (
                                          <>
                                            <p>
                                              Le CUS a pour objectif de devenir
                                              un leader en matière d'éducation,
                                              de recherche et d'innovation dans
                                              le domaine des sciences urbaines,
                                              en utilisant les Living Labs pour
                                              former les futurs dirigeants
                                              urbains et trouver des solutions
                                              innovantes à des problèmes urbains
                                              complexes. Le centre cherche à
                                              améliorer la gestion urbaine et le
                                              bien-être des citoyens en
                                              transformant les données
                                              collectées par les Living Labs
                                              pour les rendre durables, viables,
                                              solidaires et rentables. Il
                                              s'efforcera également de former la
                                              prochaine génération d'ingénieurs
                                              en systèmes urbains, de stimuler
                                              la réflexion sur les villes
                                              marocaines et africaines et de
                                              promouvoir l'excellence dans
                                              l'ingénierie des systèmes urbains.
                                              Pour atteindre ces objectifs, le
                                              CUS doit créer un écosystème pour
                                              une école des systèmes urbains,
                                              former les futurs enseignants et
                                              se positionner sur la scène
                                              internationale.
                                            </p>
                                            <p>
                                              Notre vision intègre la théorie,
                                              la gestion de projet, l'expertise
                                              et l'innovation, en se concentrant
                                              sur les défis contemporains du
                                              développement urbain. Cette
                                              intégration n'englobe pas
                                              seulement l'innovation urbaine
                                              mais s'étend également aux
                                              approches innovantes dans
                                              l'enseignement, s'alignant ainsi
                                              sur l'orientation numérique, axée
                                              sur les données et quantitative de
                                              la recherche en études urbaines en
                                              Afrique.
                                            </p>
                                          </>
                                        )}
                                      </div>
                                    </div>
                                  </TabPanel>
                                </Tabs>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>{" "}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="rn-team-area bg_color--1 ptb--120">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title text-center mb--30">
                <span className="subtitle">
                  {isEnglish ? "Our Team" : "Notre équipe"}
                </span>
                <h2 className="title">
                  {isEnglish
                    ? "Our Team Members"
                    : "Les membres de notre équipe"}
                </h2>
              </div>
            </div>
          </div>
          <TeamHome
            column="col-lg-3 col-md-6 col-12 mt--30"
            teamStyle=""
            item="4"
          />
          <div className="row">
            <div className="col-lg-12">
              <div className="view-more-btn mt--60 text-center">
                <a className="btn-default" href="/team">
                  <span>{isEnglish ? "View More" : "Voir Plus"}</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="project-area pt--60 pb--60 bg_color--5" id="project">
        <div className="rn-slick-dot">
          <div className="container">
            <div className="row">
              <div className="col-lg-8">
                <div className="section-title text-left mb--15 mb_sm--0">
                  <span className="subtitle">
                    {isEnglish ? "Our project" : "Notre Projets"}
                  </span>
                  <h2 className="title">
                    {isEnglish
                      ? "Some of our Recent Projects"
                      : "Certaines de nos projets"}
                  </h2>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="rn-project-area line-separator">
                <div className="container">
                  <div className="row">
                    <ProjectHome />
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12">
                <div className="view-more-btn mt--60 text-center">
                  <a className="btn-default" href="/projects">
                    <span>
                      {isEnglish ? "View More Project" : "Voir plus de projet"}
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="counterup-area ptb--50 bg_image bg_image--18"
        data-black-overlay="5"
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title text-center">
                <span className="subtitle">CUS Growth</span>
                <h2 className="text-white title">CUS Growth</h2>
                <p className="text-white description">
                  {isEnglish
                    ? "All key factors for our projects in CUS"
                    : "Tous les facteurs clés pour nos projets chez CUS"}
                </p>
              </div>
            </div>
          </div>
          <CounterOne />
        </div>
      </div>

      <div className="rn-news-area pt--60 pb--60 bg_color--1">
        <div className="container">
          <div className="row align-items-end">
            <div className="col-lg-12">
              <div className="section-title text-center service-style--3">
                <span className="subtitle">
                  {isEnglish
                    ? "Collaboration et partenariats"
                    : "Collaboration and Partnership	"}
                </span>
                <h2 className="title">
                  {isEnglish ? "Latest News" : "Dernières actualités"}
                </h2>
              </div>
            </div>
          </div>
          <NewsList />
          <div className="row">
            <div className="col-lg-12">
              <div className="view-more-btn mt--60 text-center">
                <a className="btn-default" href="/news">
                  <span>{isEnglish ? "View More" : "Voir Plus"}</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="rn-partners-area pt--50 bg_color--5">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title text-center mb--30">
                <span className="subtitle">
                  {isEnglish ? "Partnerships" : "Partenariats"}
                </span>
                <h2 className="title">
                  <span>{isEnglish ? "Our Partners" : "Nos partenaires"}</span>
                </h2>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12 mt--20">
              <Brand branstyle="branstyle--2" />
            </div>
          </div>
        </div>
      </div>

      <FooterTwo />

      <div className="backto-top">
        <ScrollToTop showUnder={160}>
          <FiChevronUp />
        </ScrollToTop>
      </div>
    </Fragment>
  );
};

export default withTranslation()(HomePage);
